import { Flag } from "lucide-react";
import { useIssuesData } from "../../hooks/useIssues";
import useFeatures from "../../hooks/useRedFlag"; // Corrected import to match Alert
import { useAuth } from "../../context/authContext";
import GlassCard from "../ui/GlassCard";
import StatPill from "../ui/StatPill";

const RedFlagTrigger = () => {
  const { code } = useAuth();
  // const { issuesData, loading: issuesLoading } = useIssuesData(code);
  const { features, loading: featuresLoading } = useFeatures(code);

  // Safe navigation with optional chaining & default values
  const totalCount = features?.redFlagAttacks?.totalCount ?? 0;

  const isLoading =  featuresLoading;

  return (
    <GlassCard accent="magenta" className="text-slate-900 dark:text-white">
      <StatPill
        icon={<Flag size={20} />}
        value={isLoading ? "..." : totalCount}
        label="Red Flags Triggered"
        accent="#F0498C"
      />
    </GlassCard>
  );
};

export default RedFlagTrigger;